module.exports = __webpack_public_path__ + "img/kitchen.0f94c6a0.jpg";